import React, { useState, useEffect } from "react";
import { db, auth, storage } from "../../firebaseConfig"; // Firebase bağlantısı
import { doc, getDoc, updateDoc } from "firebase/firestore"; // Firestore işlemleri
import { ref, uploadBytes, getDownloadURL } from "firebase/storage"; // Storage işlemleri
import toast from "react-hot-toast";

function Ustpage() {
  const [data, setData] = useState({
    baslik: "",
    img: "",
    eklenmetarih: "",
    silinmetarih: "",
  });
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [userClaims, setUserClaims] = useState(null);

  const documentId = "apO5zgh24azwvhskL4gb"; // Belirtilen ID

  // Kullanıcı yetkilerini kontrol et
  useEffect(() => {
    const checkUserClaims = async () => {
      try {
        const user = auth.currentUser;
        if (!user) {
          toast.error("Kullanıcı oturum açmamış. Yönlendiriliyorsunuz...");
          setTimeout(() => {
            window.location.href = "/login";
          }, 3000);
          return;
        }
        const idTokenResult = await user.getIdTokenResult();
        const claims = idTokenResult.claims;
        setUserClaims(claims);
      } catch (error) {
        console.error("Yetki kontrolü yapılırken hata oluştu:", error);
        toast.error("Yetki kontrolü başarısız.");
      } finally {
        setIsLoading(false);
      }
    };

    checkUserClaims();
  }, []);

  // Firestore'dan veri çekme
  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, "buyuksehir_ustgorsel", documentId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setData(docSnap.data());
          setPreview(docSnap.data().img);
        } else {
          toast.error("Veri bulunamadı.");
        }
      } catch (error) {
        console.error("Veri çekilirken hata oluştu:", error);
        toast.error("Veri çekilirken hata oluştu.");
      }
    };

    fetchData();
  }, []);

  // Görsel seçme işlemi
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!file.type.startsWith("image/")) {
        toast.error("Lütfen geçerli bir görsel dosyası seçin.");
        return;
      }
      setImage(file);
      setPreview(URL.createObjectURL(file));
    } else {
      toast.error("Dosya seçilmedi.");
    }
  };

  // Güncelleme işlemi
  const handleUpdate = async () => {
    if (!userClaims?.is_admin && !userClaims?.is_editor) {
      toast.error("Bu işlemi yapmak için yetkiniz yok.");
      return;
    }

    try {
      let downloadURL = data.img;

      if (image) {
        // Yeni görsel yükleme
        const storageRef = ref(storage, `ustgorsel/${documentId}-${image.name}`);
        await uploadBytes(storageRef, image);
        downloadURL = await getDownloadURL(storageRef);
      }

      // Firestore güncelleme
      const docRef = doc(db, "buyuksehir_ustgorsel", documentId);
      await updateDoc(docRef, {
        baslik: data.baslik,
        img: downloadURL,
        eklenmetarih: data.eklenmetarih || new Date().toISOString(),
        silinmetarih: data.silinmetarih || "",
      });

      toast.success("Görsel başarıyla güncellendi.");
      setImage(null);
    } catch (error) {
      console.error("Görsel güncellenirken hata oluştu:", error);
      toast.error("Görsel güncellenirken hata oluştu.");
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
      </div>
    );
  }

  if (!userClaims?.is_admin && !userClaims?.is_editor) {
    return (
      <div className="flex items-center justify-center h-screen">
        <h1 className="text-2xl font-bold text-red-500">Bu sayfaya erişim izniniz yok.</h1>
      </div>
    );
  }

  return (
    <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6 max-w-7xl mx-auto">
      <div className="bg-white p-6 rounded shadow">
        <h1 className="text-2xl font-bold mb-6">Üst Görsel</h1>
        <div className="space-y-4">
          <label>
            Başlık:
            <input
              type="text"
              className="w-full p-2 border border-gray-300 rounded-lg"
              value={data.baslik}
              onChange={(e) => setData({ ...data, baslik: e.target.value })}
            />
          </label>
          {preview && (
            <div className="relative">
              <img
                src={preview}
                alt="Preview"
                className="w-full h-60 object-cover rounded-md mb-4"
              />
            </div>
          )}
          <label htmlFor="fileInput" className="block w-full p-2 border border-dashed rounded cursor-pointer">
            Görsel Yükle
            <input
              id="fileInput"
              type="file"
              accept="image/*"
              className="hidden"
              onChange={handleFileChange}
            />
          </label>
          <button
            className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
            onClick={handleUpdate}
          >
            Güncelle
          </button>
        </div>
      </div>
      <div className="bg-gray-100 p-6 rounded shadow flex flex-col items-center">
  <h2 className="text-xl font-bold mb-4 text-center">Mobil Görünüm</h2>
  <div className="relative bg-black rounded-[50px] overflow-hidden border-8 border-black shadow-lg w-[90%] md:w-[50%] aspect-[9/16]">
    <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-[15%] h-4 bg-black rounded-b-[20px] z-10"></div>
    <div className="absolute inset-0 bg-white rounded-[45px]">
      {data.img ? (
        <img
          src={data.img}
          alt={data.baslik}
          className="w-full h-40 object-cover rounded-md"
        />
      ) : (
        <div className="flex items-center justify-center h-full text-gray-500">
          Görsel yüklenmedi.
        </div>
      )}
    </div>
  </div>
  <p className="text-sm text-gray-600 mt-4">
    * 1920x1080 çözünürlükte görsel yüklemelisiniz.
  </p>
</div>


    </div>
  );
}

export default Ustpage;
